import { AppRouter } from '@app/routes'
import { ActiveProfileProvider } from '@shared/context/ActiveProfileContext'
import { ModalProvider } from '@shared/context/ModalContext'
import { ThemeProvider } from '@shared/context/ThemeContext'
import { QueryClientProvider } from '@tanstack/react-query'
import { ReactQueryDevtools } from '@tanstack/react-query-devtools'
import { setAuthToken } from '@utils/lib/tokens'
import { initYandexMetrika, isYandexMetrikaDisabled } from '@utils/lib/yandexMetrika'
import { useEffect } from 'react'

export const Providers = ({ client }) => {
	const token = localStorage.getItem("token");

	if(token) {
		setAuthToken(token);
	}

	useEffect(() => {
		if (!isYandexMetrikaDisabled()) {
			initYandexMetrika();
		}
	}, []);

  return (
		<QueryClientProvider client={client}>
			{process.env.REACT_APP_DEV && <ReactQueryDevtools buttonPosition='top-right'/>}
			<ActiveProfileProvider>
				<ModalProvider>
					<ThemeProvider>
						<AppRouter/>
					</ThemeProvider>
				</ModalProvider>
			</ActiveProfileProvider>
		</QueryClientProvider>
  )
}
